export default __webpack_public_path__ + "static/media/atome_banner_En.f7962071.webp";